import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export default class GetRelatedAdsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPAdsRepository} deps.repository
   */
  constructor({config, repository}) {
    super({repository})
    this._config = config
    this._repository = repository
    this._offerTypeSubscription = this._config.get('search').OFFER_TYPE_SUBSCRIPTION
  }

  /**
   * @return {Promise<AdsValueObject, Error>} returns the related ads to an specific ad id
   */
  @inlineError
  async execute(requestVO) {
    const requestVOJson = requestVO.toJSON()
    const {offerTypeId} = requestVOJson
    const isRenting = offerTypeId === this._offerTypeSubscription
    const getRelatedAdsRepositoryFn = isRenting ? this._repository.getRelatedRentingAds : this._repository.getRelatedAds
    const [error, response] = await getRelatedAdsRepositoryFn(requestVO)

    if (error) {
      return Promise.reject(error)
    }

    return response
  }
}
